﻿import { FIQAssist } from "../app";
import { Inject, Injectable } from "@fiqas/angular-utils";

@Injectable({
    module: FIQAssist,
    selector: FileReaderService.selector
})
/**
 * Session class, stores values as JSON in local browser storage.
 */
export class FileReaderService {
    public static selector = "fileReaderService";

    constructor(
        @Inject('$q') private $q: ng.IQService) {
    }

    private getReader(deferred): FileReader {
        var reader = new FileReader();

        reader.onload = function () {
            deferred.resolve(reader.result);
        };

        reader.onerror = function () {
            deferred.reject(reader.error);
        };

        return reader;
    }

    public ReadAsDataUrl(file: File) {
        var deferred = this.$q.defer(),
            reader = this.getReader(deferred);
        reader.readAsDataURL(file);
        return deferred.promise;
    }

    public ReadAsText(file: File): ng.IPromise<string> {
        var deferred = this.$q.defer(),
            reader = this.getReader(deferred);
        reader.readAsText(file);
        return deferred.promise;
    }

    public ReadAsArrayBuffer(file: File): ng.IPromise<ArrayBuffer> {
        var deferred = this.$q.defer(),
            reader = this.getReader(deferred);
        reader.readAsArrayBuffer(file);
        return deferred.promise;
    }

    public ReadAsBinaryString(file: File): ng.IPromise<string> {
        if (FileReader.prototype.readAsBinaryString) {
            var deferred = this.$q.defer(),
                reader = this.getReader(deferred);
            reader.readAsBinaryString(file);
            return deferred.promise;
        }
        return this.ReadAsArrayBuffer(file).then<string>(x => {
            var u8Array = new Uint8Array(x);
            var i, len = u8Array.length, b_str = "";
            for (i = 0; i < len; i++) {
                b_str += String.fromCharCode(u8Array[i]);
            }
            return b_str;
        });
    }
}